export class SearchLocation {
  name: string
  locality: string
  stationType: SearchLocationType
  localityRef: string
  latitude: number
  longitude: number
  quality: number
  constructor(
    name: string,
    locality: string,
    stationTypes: SearchLocationType,
    localityRef: string,
    latitude: number,
    longitude: number,
    quality: number
  ) {
    this.name = name
    this.locality = locality
    this.stationType = stationTypes
    this.localityRef = localityRef
    this.latitude = latitude
    this.longitude = longitude
    this.quality = quality
  }
}

export enum SearchLocationType {
  address,
  station,
  poi,
  location
}
